const isServer = typeof window === 'undefined';

export const getApiBase = (): string => {
  if (isServer) {
    return process.env.WP_API_INTERNAL ?? 'http://localhost';
  }
  return '';
};

export const buildRestUrl = (
  route: string,
  query?: Record<string, string>,
): string => {
  const params = new URLSearchParams({ rest_route: route, ...query });
  return `${getApiBase()}/?${params.toString()}`;
};

export const fetchJson = async <T,>(url: string): Promise<T> => {
  const response = await fetch(url, {
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    throw new Error(
      `WordPress API request failed: ${response.status} ${response.statusText} (${url})`,
    );
  }

  return (await response.json()) as T;
};
